<template>
	<div v-if="showLanguageBtn" :class="buttonClass" @click="handleLangChange">
		<!-- PC版本 -->
		<template v-if="mode === 'pc'">
			<SvgIcons :name="languageIcon" class="c-action-svg" />
			<span class="action-block-span">{{ languageLabel }}</span>
		</template>

		<!-- 移动端版本 -->
		<template v-else>
			<img :src="getMobLangImg" alt="" />
		</template>
	</div>
</template>

<script setup>
import { computed, inject, onMounted, ref } from 'vue';
import { useLanguageSwitch } from '../hooks/useLanguageSwitch.js';
import i18n from '@/locales';

const mode = inject('mode');
const buttonClass = inject('normalButtonClass');

const { languageMap, showLanguageBtn, handleLangChange } = useLanguageSwitch();

// PC端语言图标 & 文案
const languageIcon = ref('');
const languageLabel = ref('');

const initActionLang = val => {
	languageIcon.value = languageMap[val].icon;
	languageLabel.value = languageMap[val].label;
};
onMounted(() => {
	initActionLang(i18n.locale);
});

const getMobLangImg = computed(() => {
	return languageMap[i18n.locale].mobIcon;
});
</script>
